module.exports = __webpack_public_path__ + "img/UI_RMYX_BG_01_ee3471ff1.png";